import { z } from '@hono/zod-openapi'
import { benefitTypesTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export const zSelectBenefitTypes = createSelectSchema(benefitTypesTable)

export const zInsertBenefitTypes = createInsertSchema(benefitTypesTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})

export const zUpdateBenefitTypes = zInsertBenefitTypes.partial()

export const zQueryBenefitTypes = zInsertBenefitTypes
    .extend({
        id: z.string(),
        ids: z.string().array(),
        isActive: z
            .union([
                z.boolean(),
                z.enum(['true', 'false']).transform((val) => val === 'true'),
            ])
            .optional(),
    })
    .extend(zCommonQuery.shape)
    .partial()

export type SelectBenefitTypes = z.infer<typeof zSelectBenefitTypes>
export type InsertBenefitTypes = z.infer<typeof zInsertBenefitTypes>
export type UpdateBenefitTypes = z.infer<typeof zUpdateBenefitTypes>
export type QueryBenefitTypes = z.infer<typeof zQueryBenefitTypes>
export type ColumnsOfBenefitTypesTable =
    keyof typeof benefitTypesTable._.columns
